export default __webpack_public_path__ + "static/media/link-logo-row.935c2579.jpg";